export default __webpack_public_path__ + "src/_images/garage_check.png";